import { Alert, Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import type { SubTopicDatabase, SubTopicWithLastActivityWithIdDatabase } from '../../../../types';
import SubTopicAutocomplete from '../../external-components/SubTopicAutocomplete/SubTopicAutocomplete';
import { useMergeSubTopicModal } from './useMergeSubTopicModal';

// Keeps the French quotes on the sub-topic name's line.
const NBSP = ' ';

type Props = {
  subTopic: SubTopicDatabase | SubTopicWithLastActivityWithIdDatabase;
  onClose: () => void;
};

export default function MergeSubTopicModal(props: Props) {
  const hook = useMergeSubTopicModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      maxWidth="sm"
      fullWidth
      title="Fusionner le sous-sujet"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Fusionner',
          onClick: hook.handleConfirm,
          loading: hook.isPending,
          disabled: !hook.targetId,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Typography variant="body1">
          Tous les éléments de «{NBSP}{props.subTopic.name}{NBSP}» (historique, tâches, rappels, documents, rendez-vous) seront transférés vers le sous-sujet choisi, puis «{NBSP}{props.subTopic.name}{NBSP}» sera supprimé.
        </Typography>

        <SubTopicAutocomplete
          label="Sous-sujet de destination"
          value={hook.targetId}
          onChange={hook.setTargetId}
          excludeIds={[props.subTopic.id]}
          fullWidth
          required
          autoFocus
        />

        <Typography variant="body2">Cette action est irréversible.</Typography>
      </Stack>
    </Dialog>
  );
}
